import { Pipe, PipeTransform } from '@angular/core';
import { getScheduleText, Schedule } from '@greco-fit/scaffolding';

@Pipe({ name: 'scheduleText' })
export class ScheduleTextPipe implements PipeTransform {
  transform(schedule: Schedule): string | null {
    return getScheduleText(schedule);
  }
}
